import { useState } from "react";
import { api } from "../../../../../../../../utility/api";

export const RecepcionIngresoApi = () => {
    const [cargando, setCargando] = useState(false);

    const guardarEstadoRecepcion = async (data) => {
        try {
            setCargando(true);
            const response = await api.post("prod_bodega_ingresos/update_recibido_bodega", data);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    return {
        guardarEstadoRecepcion,

        cargando,
    };
};
